export default function personsoccupationslistte() {
  const list = [
    { label: 'నటుడు', value: 'నటుడు' },
    { label: 'ఎడిటర్', value: 'ఎడిటర్' },
    { label: 'డైరెక్టర్', value: 'డైరెక్టర్' },
    { label: 'నిర్మాత', value: 'నిర్మాత' },
    { label: 'స్క్రీన్ రైటర్', value: 'స్క్రీన్ రైటర్' },
    { label: 'ఫిల్మ్ డైరెక్టర్', value: 'ఫిల్మ్ డైరెక్టర్' },
    { label: 'రికార్డ్ ప్రొడ్యూసర్ ఫిల్మ్', value: 'రికార్డ్ ప్రొడ్యూసర్ ఫిల్మ్' },
    { label: 'కంపోజర్ సింగర్టే', value: 'కంపోజర్ సింగర్టే' },
    { label: 'గీత రచయిత', value: 'గీత రచయిత' },
    { label: 'ఫిల్మిడిటోర్టే', value: 'ఫిల్మిడిటోర్టే' },
    { label: 'కామెడీ రచయిత', value: 'కామెడీ రచయిత' },
    { label: 'సినిమాటోగ్రాఫర్', value: 'సినిమాటోగ్రాఫర్' },
    { label: 'ఫిల్మ్ ప్రొడ్యూసర్టే', value: 'ఫిల్మ్ ప్రొడ్యూసర్టే' },
    { label: 'హాస్యనటుడు', value: 'హాస్యనటుడు' },
    { label: 'టెలివిజన్ హోస్ట్', value: 'టెలివిజన్ హోస్ట్' },
    { label: 'మోడల్', value: 'మోడల్' },
    { label: 'ప్రేరణాత్మక ప్రసంగం', value: 'ప్రేరణాత్మక ప్రసంగం' },
    { label: 'కొరియోగ్రాఫర్ట్', value: 'కొరియోగ్రాఫర్ట్' },
    { label: 'సబ్ ఇన్‌స్పెక్టర్', value: 'సబ్ ఇన్‌స్పెక్టర్' },
    { label: 'సంగీత దర్శకత్వం', value: 'సంగీత దర్శకత్వం' },
    { label: 'సింగర్టే', value: 'సింగర్టే' },
    { label: 'డాన్సర్టే', value: 'డాన్సర్టే' },
    { label: 'లాయర్', value: 'లాయర్' },
    { label: 'సోషల్ యాక్టివిస్ట్', value: 'సోషల్ యాక్టివిస్ట్' },
    { label: 'రచయిత', value: 'రచయిత' },
    { label: 'సంగీత స్వరకర్త', value: 'సంగీత స్వరకర్త' },
    { label: 'సంగీత నిర్మాత', value: 'సంగీత నిర్మాత' },
    { label: 'న్యాయమూర్తి', value: 'న్యాయమూర్తి' },
    { label: 'మాజీ వైద్యుడు', value: 'మాజీ వైద్యుడు' },
    { label: 'థియేటర్ ఆర్టిస్ట్', value: 'థియేటర్ ఆర్టిస్ట్' },
    { label: 'కార్పొరేట్ లీడర్టే', value: 'కార్పొరేట్ లీడర్టే' },
    { label: 'మెంటోర్టే', value: 'మెంటోర్టే' },
    { label: 'టెలివిజన్ ప్రెజెంటర్', value: 'టెలివిజన్ ప్రెజెంటర్' },
    { label: 'నవల', value: 'నవల' },
    { label: 'నాటక రచయిత', value: 'నాటక రచయిత' },
    { label: 'సంగీతకారుడు', value: 'సంగీతకారుడు' },
    { label: 'సభాపతి', value: 'సభాపతి' },
    { label: 'డైలాగ్ రైటర్', value: 'డైలాగ్ రైటర్' },
    { label: 'అడ్డైరెక్టర్', value: 'అడ్డైరెక్టర్' },
    { label: 'చిత్ర నిర్మాత', value: 'చిత్ర నిర్మాత' },
    { label: 'జంతు సంక్షేమ కార్యకర్త', value: 'జంతు సంక్షేమ కార్యకర్త' },
    { label: 'ఫిల్మ్‌స్కోర్టే', value: 'ఫిల్మ్‌స్కోర్టే' },
    { label: 'స్వరకర్త తె', value: 'స్వరకర్త తె' },
    { label: 'సౌండ్‌డిజైనర్టే', value: 'సౌండ్‌డిజైనర్టే' },
    { label: 'సౌండ్ ఎడిటర్', value: 'సౌండ్ ఎడిటర్' },
    { label: 'ప్రొడక్షన్ సౌండ్', value: 'ప్రొడక్షన్ సౌండ్' },
    { label: 'బాల నటి', value: 'బాల నటి' },
    { label: 'వరల్డ్ మ్యూజిక్', value: 'వరల్డ్ మ్యూజిక్' },
    { label: 'లైఫ్ కోచ్టే', value: 'లైఫ్ కోచ్టే' },
    { label: 'ప్లేబ్యాక్సింగర్టే', value: 'ప్లేబ్యాక్సింగర్టే' },
    { label: 'ఫ్యాషన్ డిజైనర్', value: 'ఫ్యాషన్ డిజైనర్' },
    { label: 'ప్రపంచ సంగీతం', value: 'ప్రపంచ సంగీతం' },
    { label: 'వ్యాపారవేత్త', value: 'వ్యాపారవేత్త' },
    { label: 'మోటివేషనల్ స్పీకర్', value: 'మోటివేషనల్ స్పీకర్' },
    { label: 'రేడియో జాకీట్', value: 'రేడియో జాకీట్' },
    { label: 'టీవి ప్రసారం హోస్ట్', value: 'టీవి ప్రసారం హోస్ట్' },
    { label: 'కాలమిస్ట్', value: 'కాలమిస్ట్' },
    { label: 'టెలివిజన్ పర్సనాలిటీ', value: 'టెలివిజన్ పర్సనాలిటీ' },
    { label: 'డైరెక్టరోఫోటోగ్రఫీ', value: 'డైరెక్టరోఫోటోగ్రఫీ' },
    { label: 'రాజకీయ నాయకుడు', value: 'రాజకీయ నాయకుడు' },
    { label: 'ఫిల్మ్ స్కాలర్టే', value: 'ఫిల్మ్ స్కాలర్టే' },
    { label: 'సాంస్కృతిక సిద్ధాంతకర్త', value: 'సాంస్కృతిక సిద్ధాంతకర్త' },
    { label: 'నటి', value: 'నటి' },
    { label: 'ట్రాక్ అండ్ ఫీల్డ్ అథ్లెట్', value: 'ట్రాక్ అండ్ ఫీల్డ్ అథ్లెట్' },
    { label: 'కమ్యూనిస్టు నాయకుడు', value: 'కమ్యూనిస్టు నాయకుడు' },
    { label: 'రాపర్టే', value: 'రాపర్టే' },
    { label: 'సినిమా విమర్శకుడు', value: 'సినిమా విమర్శకుడు' },
    { label: 'తహసీల్దార్తే', value: 'తహసీల్దార్తే' },
    { label: 'వాగ్గేయకరతే', value: 'వాగ్గేయకరతే' },
    { label: 'సివిల్‌ ఇంజినీర్‌ టీ', value: 'సివిల్‌ ఇంజినీర్‌ టీ' },
    { label: 'వాయిద్యకారుడు', value: 'వాయిద్యకారుడు' },
    { label: 'ఏర్పాటు', value: 'ఏర్పాటు' },
    { label: 'కార్యక్రమం', value: 'కార్యక్రమం' },
  ]
  return list
}
